export default __webpack_public_path__ + "static/media/planner-16px.78e35658.svg";